import { render, staticRenderFns } from "./TournamentRowActions.vue?vue&type=template&id=4f4e24a4&scoped=true"
import script from "./TournamentRowActions.vue?vue&type=script&lang=js"
export * from "./TournamentRowActions.vue?vue&type=script&lang=js"
import style0 from "./TournamentRowActions.vue?vue&type=style&index=0&id=4f4e24a4&prod&scoped=true&lang=scss"
import style1 from "./TournamentRowActions.vue?vue&type=style&index=1&id=4f4e24a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4e24a4",
  null
  
)

export default component.exports